// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
/** Lazy loader for the UpsellStatusContainer */ export const UpsellStatusContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-upsellstatus" */ "./UpsellStatusContainer")).then((bundle)=>{
        return {
            default: bundle.UpsellStatusContainer
        };
    });
/** Lazy-loaded UpsellStatusContainer */ export const LazyUpsellStatusContainer = /*#__PURE__*/ lazy(UpsellStatusContainerLazyLoader);
